<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <span class="item">订单管理</span>
            <em class="gap">/</em>
            <span class="item">下单列表</span>
        </div>
        <div class="cg-main-title">
            下单列表
            <div class="link-wrap">
                <button class="cg-btn" @click="toListLock">锁仓列表</button>
                <button class="cg-btn mgl-16" @click="toListClear">清算列表</button>
            </div>
        </div>
        <div class="header-handle">
            <div class="cg-search-box">
                <el-input
                    size="mini"
                    placeholder="ID/商品名称/款号"
                    prefix-icon="el-icon-search"
                    v-model.trim="searchWords"
                    clearable
                    >
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
            <!-- <div class="btns">
                <button class="cg-btn red" @click="toAddGoods">新增商品</button>
                <button class="cg-btn mgl-16" @click="exportItemInfo">下载表格</button>
            </div> -->
        </div>
        <div class="table-wrap">
            <el-table
                :data="tableData"
                v-loading="loading"
                size="small"
            >
                <!-- <el-table-column
                    type="selection"
                    align="center"
                    width="55"
                >
                </el-table-column> -->
                <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="50"
                    :index="indexMethod"
                >
                </el-table-column>
                <el-table-column
                    prop="order_number"
                    label="下单订单号"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                prop="productMainImageFile"
                label="图片"
                width="80">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.productMainImageFile"
                            fit="cover"
                            :preview-src-list="[scope.row.productMainImageFile]"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="item_name"
                    label="商品名称"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    prop="styleNumber"
                    label="款号"
                    width="90"
                >
                </el-table-column>
                <el-table-column
                    prop="item_order_price"
                    label="价格(元)"
                    width="80"
                >
                    <template slot-scope="scope">
                        {{scope.row.item_order_price | price}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="dealerName"
                    label="销售商"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="order_purchase_quantity"
                    label="下单数"
                    width="60"
                >
                </el-table-column>
                <el-table-column
                    prop="sumOrderReserveQuantity"
                    label="锁仓数"
                    width="60"
                >
                </el-table-column>
                <el-table-column
                    prop="sumEstablishQuantity"
                    label="已核销数"
                    width="60"
                >
                </el-table-column>

                <el-table-column
                    prop="needPay"
                    label="需支付额(元)"
                    width="80"
                ></el-table-column>
                <el-table-column
                    prop="amountToBeConfirmed"
                    label="待确认金额(元)"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="paidAmount"
                    label="已确认付款(元)"
                    width="80"
                >
                </el-table-column>
                <!-- <el-table-column
                    prop="unpaidAmount"
                    label="欠款(元)"
                    width="80"
                >
                </el-table-column> -->
                <el-table-column
                    prop="order_submit_time"
                    label="下单时间"
                    width="90"
                >
                </el-table-column>
                <el-table-column
                    prop="itemState"
                    label="下单状态"
                    width="120"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.liquidateState == '4'">
                            <el-tag type="success" size="medium">已转为清算</el-tag>
                        </template>
                        <template v-else>
                            <el-tag type="success" size="medium">{{scope.row.status_pass}}</el-tag> <br>
                            <el-tag type="success" size="medium" style="margin-top: 4px">{{scope.row.status_pay}}</el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="160"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button class="cg-icon-btn" @click="toOrderDetail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button class="cg-icon-btn" v-if="scope.row.liquidateState != '4'" @click="toStartClear(scope.row)" type="text" size="small">发起清算</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="发起清算" :visible.sync="clearSurePop" width="1000px" center>
            <div class="clear-sure-top">
                <el-image
                    class="img"
                    :src="currentHandleRow.productMainImageFile"
                    fit="cover"
                >
                </el-image>
                <div class="info">
                    <span>名称：{{currentHandleRow.item_name}}</span> <br>
                    <span>款号：{{currentHandleRow.item_style_number}}</span>
                </div>
                <div class="count">共查询到{{clearOrderList.length}}条数据</div>
            </div>
            <el-table :data="clearOrderList" size="small">
                <el-table-column property="order_number" label="下单订单号" width="140"></el-table-column>
                <el-table-column property="order_purchase_quantity" label="下单数量"  width="80"></el-table-column>
                <el-table-column property="item_order_price" label="核销价(元)" width="80"></el-table-column>
                <el-table-column property="sumEstablishQuantity" label="已核销" width="80"></el-table-column>
                <el-table-column property="needPay" label="已出账单需支付" width="110"></el-table-column>
                <el-table-column property="sumPay" label="平台已确认金额" width="110"></el-table-column>
                <el-table-column property="amountToBeConfirmed" label="平台未确认金额" width="110"></el-table-column>
                <el-table-column property="unpaidAmount" label="已出账单欠款" width="100"></el-table-column>
                <el-table-column property="order_submit_time" label="下单时间" ></el-table-column>
            </el-table>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="clearSurePop = false">取 消</el-button>
                <el-button type="primary" @click="checkPaymentStatus">确认清算</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getPurchaseList, getOrderPurchaseList, launchLiquidate, checkPaymentStatus } from '../../../api/supplier'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            tableData: [],

            // 分页
            pageSize: 10,
            total: 0,
            currentPage: 1,

            // 清算确认弹框
            clearSurePop: false,
            clearOrderList: [],
            currentHandleRow: {},
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
        console.log(this.$route.query);
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.getOrderList();
            },
            immediate: true
        }
    },
    methods: {
        getOrderList() {
            this.loading = true
            getPurchaseList({
                "supplierUserId": this.userId,
                "dealerUserId": "",
                "page": this.currentPage,
                "num": this.pageSize,
                "fuzzyQuery": this.searchWords,
            }).then(res => {
                this.loading = false
                console.log('getOrderList', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.orderList.map(item => {

                        let status_pass = ''
                        let status_pay = ''

                        if (!item.sumEstablishQuantity) {status_pass = '从未核销'}
                        else if (item.sumEstablishQuantity < item.order_purchase_quantity) {status_pass = '部分核销'}
                        else if (item.sumEstablishQuantity == item.order_purchase_quantity) {status_pass = '全部核销'}

                        if (!item.paidAmount) {status_pay = '从未付款'}
                        else if (item.unpaidAmount > 0) {status_pay = '部分付款'}
                        else if (item.unpaidAmount == 0) {status_pay = '全部付款'}


                        let paidAmount, unpaidAmount
                        item.paidAmount == undefined || item.paidAmount === '' ? paidAmount = '/' : paidAmount = item.paidAmount
                        item.unpaidAmount == undefined || item.unpaidAmount === '' ? unpaidAmount = '/' : unpaidAmount = item.unpaidAmount

                        return {
                            ...item,
                            status_pass,
                            status_pay,
                            paidAmount,
                            unpaidAmount,
                            productMainImageFile: process.env.VUE_APP_IMG_PREV + item.productMainImageFile
                        }
                    })
                    this.total = parseInt(res.data.totalCount)
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log(err)
            })
        },
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
        },

        toOrderDetail(row) {
            this.$router.push('/supplier/order/detail-order?orderNumber=' + row.order_number)
        },

        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/supplier/order/list-order?search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.curRoutePush()
        },
        toListLock() {
            this.$router.push('/supplier/order/list-lock')
        },
        toListClear() {
            this.$router.push('/supplier/order/list-clear')
        },
        // 发起清算
        toStartClear(row) {
            this.clearSurePop = true
            this.currentHandleRow = row
            this.getCanClearOrder(row)
        },
        // 获取可清算订单
        getCanClearOrder(row) {
            getOrderPurchaseList({
                "supplierUserId": row.supplier_user_id,
                "dealerUserId": row.dealer_user_id,
                "itemId": row.item_id
            }).then(res => {
                
                console.log('getOrderPurchaseList', res)
                if (res.errorCode == 200) {
                    this.clearOrderList = res.data
                } else {
                    this.$message.error(res.errorMsg || '获取数据失败')
                }
            }).catch(err=> {
                
                console.log(err)
            })
        },
        // 检查检查有没有付款没有确认的订单
        checkPaymentStatus() {
            checkPaymentStatus({
                "supplierUserId": this.currentHandleRow.supplier_user_id,
                "dealerUserId": this.currentHandleRow.dealer_user_id,
                "itemId": this.currentHandleRow.item_id
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.launchLiquidate()
                } else {
                    this.$message.error(res.errorMsg || '网络异常')
                    // -19999 还有付款信息没有确认
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        // 发起清算 api
        launchLiquidate() {
            launchLiquidate({
                "supplierUserId": this.currentHandleRow.supplier_user_id,
                "dealerUserId": this.currentHandleRow.dealer_user_id,
                "itemId": this.currentHandleRow.item_id,
                "orderState": "2",
                // "liquidateOrderId":"",
                "orderSubmitType": "supplier"
            })
            .then(res => {
                console.log(res);
                if (res.errorCode == 200) {
                    this.$message.success(res.errorMsg || "操作成功");
                    this.clearSurePop = false
                    this.currentHandleRow = {}
                    this.clearOrderList = []
                    this.getOrderList()
                } else {
                    this.$message.error(res.errorMsg || "操作是失败");
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 900px;
}
.header-handle {
    margin-top: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .cg-search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.table-wrap {
    margin-top: 8px
}
.el-image {
    display: block;
}
.clear-sure-top {
    height: 64px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
    position: relative;
    .img {width: 64px; height: 64px; float: left; border: 1px solid #eee}
    .info {padding-left: 80px;}
    .count {position: absolute; right: 0; bottom: 10px; font-size: 12px; color: #333; line-height: 1;}
}
</style>